import { render, staticRenderFns } from "./DeleteConvenienceMenus.vue?vue&type=template&id=1a2714cc"
import script from "./DeleteConvenienceMenus.vue?vue&type=script&lang=js"
export * from "./DeleteConvenienceMenus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports